import React, { useState } from "react"
import axios from "axios"
import { Box, Checkbox, Label } from "@theme-ui/components"
import SectionTitle from "./sectionTitle"
import { LangContext } from "../context/langContext"

const ContactFormFull = () => {
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [company, setCompany] = useState("")
  const [body, setBody] = useState("")
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const handleSubmit = event => {
    event.preventDefault()
    setLoading(true)
    const data = {
      name: name,
      email: email,
      company: company,
      body: body,
    }
    axios
      .post("/.netlify/functions/sendMail", data)
      .then(function (response) {
        setSuccess(true)
        setLoading(false)
        if (typeof window !== "undefined" && window.dataLayer !== undefined) {
          window.dataLayer.push({
            event: "form_submit",
          })
        }
      })
      .catch(function (error) {
        console.log("error", error)
        setLoading(false)
      })
  }

  return (
    <LangContext.Consumer>
      {t => (
        <Wrapper>
          <form method="post" name="download" onSubmit={handleSubmit}>
            <section>
              <label htmlFor="name">{t.fullName}</label>
              <input
                onChange={e => setName(e.target.value)}
                type="text"
                name="name"
                id="name"
                value={name}
                required
              />
            </section>
            <section>
              <label htmlFor="email">Email</label>
              <input
                onChange={e => setEmail(e.target.value)}
                type="email"
                name="email"
                id="email"
                value={email}
                required
              />
            </section>
            <section>
              <label htmlFor="company">{t.company}</label>
              <input
                onChange={e => setCompany(e.target.value)}
                type="company"
                name="company"
                id="company"
                value={company}
                required
              />
            </section>
            <section>
              <label htmlFor="body">{t.message}</label>
              <textarea
                onChange={e => setBody(e.target.value)}
                type="body"
                name="body"
                id="body"
                value={body}
                required
              />
            </section>
            <section>
              <p>{t.consentPolicy}</p>
              <Label htmlFor="privacy">
                <Checkbox id="privacy" name="privacy" required />
                {t.consent}
              </Label>
            </section>
            <section>
              {!success && (
                <input
                  type="submit"
                  value={loading ? `${t.loading}...` : t.submit}
                />
              )}
              {success && <input type="submit" value={t.submitted} disabled />}
            </section>
          </form>
        </Wrapper>
      )}
    </LangContext.Consumer>
  )
}

export default ContactFormFull

// const Checkbox = styled.div`
//   display: flex;
//   flex-direction: row;
//   input {
//     margin-right: 0.5rem;
//   }
//   label {
//     font-size: 14px;
//     line-height: 1.1;
//     margin-bottom: 0 !important;
//   }
// `

const Wrapper = props => (
  <Box
    {...props}
    as="div"
    sx={{
      form: {
        label: {
          marginBottom: 2,
          color: "dark",
          fontSize: 1,
        },
        "input, textarea": {
          paddingX: 3,
          paddingY: 2,
          width: "100%",
          color: "dark",
          border: "none",
          fontSize: 2,
          backgroundColor: "transparent",
          borderBottom: "1px solid",
          borderColor: "primary",
        },
        "input[type='submit']": {
          paddingX: 4,
          paddingY: 3,
          color: "light",
          backgroundColor: "primary",
          border: "1px solid",
          borderColor: "primary",
          fontWeight: "bold",
          cursor: "pointer",
        },
        checkbox: {
          label: {
            fontSize: 0,
          },
        },
        section: {
          display: "inline-flex",
          flexDirection: "column",
          mb: 4,
          width: "100%",
          p: {
            fontSize: 0,
            color: "rgba(0, 0, 0, 0.3)",
          },
        },
      },
    }}
  ></Box>
)

// const Wrapper = styled.div`
//   border-radius: ${DesignTokens.borderRadius};
//   form {
//     padding-top: 2rem;
//     label {
//       margin-bottom: 0.5rem;
//       color: white;
//       font-size: 14px;
//     }
//     input,
//     textarea {
//       padding: ${DesignTokens.spacing[4]};
//       color: black;
//       border: none;
//       font-size: 1rem;
//       border-radius: 0.25rem;
//       background: white;
//       border: 1px solid white;
//     }

//     input[type="submit"] {
//       background: white;
//       border: none;
//       color: ${DesignTokens.colors.primary[500]};
//       text-transform: uppercase;
//       font-weight: bold;
//       padding-top: 1.5rem;
//       padding-bottom: 1.5rem;
//       border-radius: 1000rem;
//       cursor: pointer;
//       &:hover,
//       &:active {
//         background: ${DesignTokens.colors.secondary[500]};
//         color: white;
//       }
//       &:disabled {
//         background: #4caf50;
//         cursor: default;
//         color: white;
//       }
//     }
//     section {
//       display: flex;
//       flex-direction: column;
//       p {
//         font-size: 12px;
//         color: rgba(255, 255, 255, 0.6);
//       }
//     }
//     & > * {
//       margin-bottom: ${DesignTokens.spacing[4]};
//       &:last-child {
//         margin-bottom: 0;
//       }
//     }
//   }
// `
